// extracted by mini-css-extract-plugin
module.exports = {"filter_selected":"chips_filter_selected__mTwbG","image_container":"chips_image_container__-9S8D","image":"chips_image__bue66"};